import { getCorrectFilePath } from "@/helpers/new/getCorrectFilePath";
import noAvatar from "@/images/noAvatar.png";

export const getRightWord = (value, words) =>{
    value = Math.abs(value) % 100;
    var num = value % 10;
    if (value > 10 && value < 20) return words[2];
    if (num > 1 && num < 5) return words[1];
    if( num == 1) return words[0];
    return words[2];
};

const screenWidth = window.innerWidth;
// const screenHeight = window.innerHeight;
const isMobile = screenWidth < 540;
export const checkWidth = (page, unReadChats) => {
    if (isMobile && page !== 'default') {
        return screenWidth * 0.97;
    } else if (!isMobile && page !== 'default') {
        return screenWidth * 0.8;
    } else if (!isMobile && page === 'default') {
        if (unReadChats?.length === 0) {
            return 100
        } else {
            return 232
        }
    } else if (isMobile && page === 'default') {
        if (unReadChats?.length === 0) {
            return 100
        } else {
            return screenWidth * 0.9;
        }
    }
}
export const checkHeight = (page) => {
    const screenHeight = window.innerHeight;
    if (isMobile && page !== 'default') {
        return screenHeight * 0.8;
    } else if (!isMobile && page !== 'default') {
        return screenHeight * 0.8;
    } else if (!isMobile && page === 'default') {
        return 60
    } else if (isMobile && page === 'default') {
        return 60
    }
}

/** Размер открытого виджета чата платформы (не свёрнутой кнопки). */
export const getPlatformChatOpenDimensions = () => {
    const page = 'inChat';
    const minWidth = checkMinWidth(page, []);
    const maxWidth = checkWidth(page, []);
    let width = minWidth;

    try {
        const fromLS = localStorage.getItem('widthChat');
        if (fromLS != null) {
            const parsed = JSON.parse(fromLS);
            if (typeof parsed === 'number' && Number.isFinite(parsed)) {
                width = parsed;
            }
        }
    } catch {
        /* невалидный widthChat в localStorage */
    }

    if (typeof maxWidth === 'number' && Number.isFinite(maxWidth)) {
        width = Math.min(width, maxWidth);
    }

    return {
        width: Math.max(width, minWidth),
        height: checkHeight(page),
    };
};

export const checkMinWidth = (page, unReadChats) => {
    if (page === 'default' && unReadChats?.length>0) {
        return 203
    } else if (page === 'default' && unReadChats?.length === 0) {
        return 100
    } else if (page !== 'default' && !isMobile) {
        return 500
    } else if(isMobile){
        return screenWidth - 16;
    } else {
        return screenWidth * 0.8
    }
}
 
export const getAvatar = (path, photo = noAvatar) => {
    if (path) {
        return getCorrectFilePath(path)
    }

    return photo;
}